import { render, staticRenderFns } from "./after_sale.vue?vue&type=template&id=2d03111e"
import script from "./after_sale.vue?vue&type=script&lang=js"
export * from "./after_sale.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports